var map = {
	"./1.mp3": 1270,
	"./10.mp3": 5266,
	"./100.mp3": 8163,
	"./11.mp3": 3051,
	"./12.mp3": 4599,
	"./13.mp3": 6769,
	"./14.mp3": 3731,
	"./15.mp3": 66,
	"./16.mp3": 6365,
	"./17.mp3": 1825,
	"./18.mp3": 9378,
	"./19.mp3": 266,
	"./2.mp3": 5740,
	"./20.mp3": 8793,
	"./21.mp3": 6208,
	"./22.mp3": 2477,
	"./23.mp3": 1479,
	"./24.mp3": 464,
	"./25.mp3": 4850,
	"./26.mp3": 8709,
	"./27.mp3": 9433,
	"./28.mp3": 4882,
	"./29.mp3": 2300,
	"./3.mp3": 4103,
	"./30.mp3": 4885,
	"./31.mp3": 2396,
	"./32.mp3": 838,
	"./33.mp3": 3679,
	"./34.mp3": 8963,
	"./35.mp3": 6387,
	"./36.mp3": 1570,
	"./37.mp3": 4514,
	"./38.mp3": 4180,
	"./39.mp3": 2932,
	"./4.mp3": 3866,
	"./40.mp3": 3877,
	"./41.mp3": 5124,
	"./42.mp3": 1145,
	"./43.mp3": 2206,
	"./44.mp3": 7763,
	"./45.mp3": 2892,
	"./46.mp3": 2425,
	"./47.mp3": 8282,
	"./48.mp3": 4171,
	"./49.mp3": 4668,
	"./5.mp3": 1804,
	"./50.mp3": 2931,
	"./51.mp3": 7929,
	"./52.mp3": 3041,
	"./53.mp3": 2972,
	"./54.mp3": 3620,
	"./55.mp3": 5077,
	"./56.mp3": 4682,
	"./57.mp3": 6673,
	"./58.mp3": 6544,
	"./59.mp3": 4822,
	"./6.mp3": 9177,
	"./60.mp3": 5083,
	"./61.mp3": 7025,
	"./62.mp3": 4986,
	"./63.mp3": 9910,
	"./64.mp3": 70,
	"./65.mp3": 1082,
	"./66.mp3": 7298,
	"./67.mp3": 2338,
	"./68.mp3": 1580,
	"./69.mp3": 8491,
	"./7.mp3": 7966,
	"./70.mp3": 623,
	"./71.mp3": 7413,
	"./72.mp3": 1116,
	"./73.mp3": 3419,
	"./74.mp3": 7935,
	"./75.mp3": 5958,
	"./76.mp3": 9296,
	"./77.mp3": 1095,
	"./78.mp3": 509,
	"./79.mp3": 9805,
	"./8.mp3": 8943,
	"./80.mp3": 9339,
	"./81.mp3": 9395,
	"./82.mp3": 1089,
	"./83.mp3": 6695,
	"./84.mp3": 210,
	"./85.mp3": 6499,
	"./86.mp3": 5456,
	"./87.mp3": 902,
	"./88.mp3": 136,
	"./89.mp3": 5997,
	"./9.mp3": 1598,
	"./90.mp3": 1226,
	"./91.mp3": 7165,
	"./92.mp3": 7655,
	"./93.mp3": 83,
	"./94.mp3": 3868,
	"./95.mp3": 5656,
	"./96.mp3": 6641,
	"./97.mp3": 3556,
	"./98.mp3": 2611,
	"./99.mp3": 341
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9242;